import React, { useState } from 'react';
import List from '@material-ui/core/List';
import {
    Flare, ListAlt, PictureAsPdf, ImportContacts, EmojiPeople, Description,
    Settings, Mail, Build, MenuBook, ErrorOutline,
    Create, GroupWork, List as ListIcon, ExpandLess, ExpandMore, SettingsInputComponent, Scanner, AccessTime, NewReleases, Chat, LocalShipping, Assignment, TrackChanges, Visibility, People, Cloud, ContactMail, Forum
} from '@material-ui/icons';
import { useAppContext } from 'hooks/useAppContext';
import SideMenuItem from 'components/Shared/SideMenuItem';
import AuthCheck from 'components/Shared/AuthCheck';
import { useAuthContext } from 'hooks/useAuthContext';
import { makeStyles, Collapse, IconButton } from '@material-ui/core';
import { checkHideShow, checkShowInspectionTreeIcon, getNestedRoutes } from 'utils/uxUtils';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(3),
    },

    nestedItem: {
        borderLeft: "2px solid",
        borderRadius: "0"
    }
}));


const Menu = () => {
    const [treeExpanded, setTreeExpanded] = useState(true);
    const context = useAppContext();
    const { selectedProject, updateCurrentModule, currentModule, currentModuleFilter, selectedProjectData } = context;
    const { role } = useAuthContext();
    const classes = useStyles();

    const handleClick = (e, value) => {
        updateCurrentModule(value);
    }

    const hanldeTreeClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setTreeExpanded(e => (!e))
    }

    return (
        role && (selectedProjectData || !selectedProject) ?
            <div>
                {selectedProject ?
                    <List>
                        {/* <AuthCheck role={role} scope="Projects" action="read">
                        <SideMenuItem key="dashboard" moduleName="Dashboard" handleClick={handleClick} icon={Dashboard} />
                    </AuthCheck> */}
                        <AuthCheck role={role} scope="Projects" action="read">
                            <SideMenuItem key="details" moduleName="Details" handleClick={handleClick} icon={MenuBook} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Inspections" action="read">
                            <SideMenuItem key="inspections" moduleName="Inspections" handleClick={handleClick} icon={Create} >
                                {checkShowInspectionTreeIcon(selectedProjectData.sectionSetting) ?
                                    treeExpanded ?
                                        <IconButton onClick={hanldeTreeClick}><ExpandLess /></IconButton> :
                                        <IconButton onClick={hanldeTreeClick} ><ExpandMore /></IconButton>
                                    : null
                                }
                            </SideMenuItem>
                        </AuthCheck>
                        <Collapse in={treeExpanded} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding className={classes.nested}>
                                {checkHideShow("Visitor", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="visitor" moduleName="Visitor" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'visitor')} handleClick={handleClick} icon={ContactMail} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Comments", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Comments" action="read">
                                        <SideMenuItem key="Comments" moduleName="Comments" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'comments')} handleClick={handleClick} icon={Chat} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("CommunicationEvent", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="communicationevent" moduleName="Communication Event" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'communicationevent')} handleClick={handleClick} icon={Forum} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Accidents", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="Accidents" moduleName="Accidents" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'accidents')} handleClick={handleClick} icon={NewReleases} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Equipment", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="Equipment" moduleName="Equipment" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'equipment')} handleClick={handleClick} icon={Scanner} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("WorkforceLabor", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="workforcelabor" moduleName="Workforce Labor" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'workforcelabor')} handleClick={handleClick} icon={People} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Delays", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="Delays" moduleName="Delays" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'delays')} handleClick={handleClick} icon={AccessTime} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {
                                    checkHideShow("Issues", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Issues" action="read">
                                        <SideMenuItem key="issues" moduleName="Issues" handleClick={handleClick} icon={ErrorOutline} className={classes.nestedItem} route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'issues')} />
                                    </AuthCheck>
                                }

                                {checkHideShow("Tests", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Tests" action="read">
                                        <SideMenuItem key="Field Tests" moduleName="Field Tests" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'fieldtests')} handleClick={handleClick} icon={ListAlt} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Deliveries", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="Deliveries" moduleName="Deliveries" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'deliveries')} handleClick={handleClick} icon={LocalShipping} className={classes.nestedItem} />
                                    </AuthCheck>
                                }


                                {checkHideShow("WeatherImpact", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="weatherimpact" moduleName="Weather Impact" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'weatherimpact')} handleClick={handleClick} icon={Cloud} className={classes.nestedItem} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Observation", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="observation" moduleName="Observations" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'observation')} handleClick={handleClick} icon={Visibility} className={classes.nestedItem} />
                                    </AuthCheck>
                                }  {checkHideShow("Samples", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Samples" action="read">
                                        <SideMenuItem key="samples" moduleName="Samples" handleClick={handleClick} icon={Flare} className={classes.nestedItem} route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'samples')} />
                                    </AuthCheck>
                                }
                                {checkHideShow("Checklist", selectedProjectData.sectionSetting) &&
                                    <AuthCheck role={role} scope="Inspections" action="read">
                                        <SideMenuItem key="checklist" moduleName="Checklist" route={getNestedRoutes(currentModule, currentModuleFilter, selectedProject, 'checklist')} handleClick={handleClick} icon={Assignment} className={classes.nestedItem} />
                                    </AuthCheck>
                                }




                            </List>
                        </Collapse>
                        <AuthCheck role={role} scope="Contacts" action="read">
                            <SideMenuItem key="contacts" moduleName="Contacts" handleClick={handleClick} icon={Mail} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Contracts" action="read">
                            <SideMenuItem key="contracts" moduleName="Contracts" handleClick={handleClick} icon={ImportContacts} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="WorkItems" action="read">
                            <SideMenuItem key="workitems" moduleName="Work Items" route={`/projects/${selectedProject}/workitems`} handleClick={handleClick} icon={GroupWork} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Resources" action="read">
                            <SideMenuItem key="resources" moduleName="Resources" handleClick={handleClick} icon={EmojiPeople} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Documents" action="read">
                            <SideMenuItem key="documents" moduleName="Documents" handleClick={handleClick} icon={Description} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Contractors" action="read">
                            <SideMenuItem key="contractors" moduleName="Contractors" handleClick={handleClick} icon={Build} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Materials" action="read">
                            <SideMenuItem key="materials" moduleName="Materials" handleClick={handleClick} icon={SettingsInputComponent} />
                        </AuthCheck>
                        <AuthCheck role={role} scope="Reports" action="read">
                            <SideMenuItem key="reports" moduleName="Reports" handleClick={handleClick} icon={PictureAsPdf} />
                        </AuthCheck>
                        {/* <AuthCheck role={role} scope="Comments" action="read">
                        <SideMenuItem key="comments" moduleName="Comments" handleClick={handleClick} icon={Comment} />
                    </AuthCheck> */}
                        <AuthCheck role={role} scope="ProjectConfig" action="read">
                            <SideMenuItem key="configuration" moduleName="Configuration" handleClick={handleClick} icon={Settings} />
                        </AuthCheck>
                    </List>
                    :
                    <List>
                        <SideMenuItem key="projects" route={'/projects'} moduleName="projects" handleClick={handleClick} icon={ListIcon}></SideMenuItem>
                    </List>
                }
            </div>
            : <span>loading...</span>
    )
};

export default Menu;
export { useStyles as useMenuStyles };